// @flow strict

export const EDITORIAL_IMAGE_WIDTH = 286;
export const EDITORIAL_IMAGE_HEIGHT = 192;
